module.exports = __webpack_public_path__ + "img/driedfruits.cbda649b.jpg";